module.exports = __webpack_public_path__ + "static/media/bakri-postpartum-balloon-product@3x.d2ca846e.jpg";